import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { FilterOptionList } from '../../../subcomponents/filter-option-list/filter-option-list';
import { Modal } from '../../../subcomponents/modal/modal';
import { getNumberOfFiltersApplied } from '../../../utils/filters';
const b = bemClassBuilder('v-single-filter-modal');
export const SingleFilterModal = observer(props => {
    const { filterId, config, options, displayText, assets, onClick, cdnOptions } = props;
    const [isOpen, setOpen] = useState(false);
    const { filterType, filter } = config;
    const closeFilter = () => {
        setOpen(false);
    };
    const toggleFilter = () => {
        setOpen(!isOpen);
    };
    const onChange = (_, value) => {
        onClick(value);
        closeFilter();
    };
    const hasFilterApplied = () => {
        return getNumberOfFiltersApplied({ id: filterId, type: filterType, keys: [filter] }) > 0;
    };
    const filterOptionListProps = {
        filterKey: filter,
        isMultiselect: false,
        options,
        onChange,
        attributeIconCdnOptions: cdnOptions.attributeIcon,
        allOptionLabel: displayText.allOptionLabel
    };
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(Button, Object.assign({ onClick: toggleFilter, className: b.element('modal-button'), iconName: assets.filterModalButtonIconName, label: displayText.modalLabel }, { children: hasFilterApplied() && (_jsx("div", Object.assign({ className: b.element('tick-container') }, { children: _jsx("div", { className: b.element('tick') }) }))) })), _jsx(Modal, Object.assign({ show: isOpen, className: b.block(), onClose: closeFilter, heading: displayText.modalLabel, footer: _jsx(Button, Object.assign({ className: b.element('cancel-button'), color: ButtonColor.Secondary, onClick: closeFilter }, { children: displayText.cancelButtonLabel })) }, { children: _jsx(FilterOptionList, Object.assign({}, filterOptionListProps)) }))] })));
});
SingleFilterModal.displayName = 'SingleFilterModal';
